const getDefaultOpenedTab = (content, activeId) => {
  const tab = content.find(
    (item) =>
      item.content && item.content.find((subItem) => subItem.id === activeId)
  );
  return tab ? tab.id : null;
};

export default getDefaultOpenedTab;
